/*
 * @Description: 退单信息查询与提交
 * @Author: 杨志航
 * @Date: 2026-05-09 15:55:12
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Checkbox,
  message,
  Drawer,
} from 'antd'
import { allTrim, filterParams, cryptoParamsIntoUrl, getExport } from '@/utils'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import SubmitInfo from '../module/SubmitInfo'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const typeList = [
  { id: 0, name: '直销订单'},
  { id: 1, name: '代理商订单'},
]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const RefundInfo = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [isZero, setIsZero] = useState(true)
  const [infoVisible, setInfoVisible] = useState(false)
  const [infoData, setInfoData] = useState({})

  useEffect(() => {
    resetParams()
    searchParams.isZero = 1
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
      type: 0,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getRefundOrderQueryList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    searchParams.isZero = 1
    setIsZero(true)
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        vals.isZero = isZero ? 1 : 0
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const changeIsZero = val => {
    const { checked } = val.target
    setIsZero(checked)
    searchParams.isZero = checked ? 1 : 0
    searchParams.page = currentPage = 1
    getList()
  }

  const handleInfo = () => {
    setInfoData(searchParams)
    setInfoVisible(true)
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="类型">
            {getFieldDecorator('type', {
              initialValue: 0,
            })(<Select 
              placeholder="请选择"
            >
              {
                typeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="厂商ID" required>
            {getFieldDecorator('vendor')(<Input placeholder="请输入厂商ID" />)}
          </FormItem>
          <FormItem label="订单负责人">
            {getFieldDecorator('currentUserName')(<Input placeholder="请输入姓名" />)}
          </FormItem>
          <FormItem label="订单负责人员工编号">
            {getFieldDecorator('currentUserNumber')(<Input placeholder="请输入员工编号" />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={handleInfo}>退单信息提交</Button>
      </div>
      <Alert className="corp-count" message={
        <>
          <span>总共{count}条数据</span>
          <span style={{ marginLeft: 20 }}><Checkbox checked={isZero} onChange={changeIsZero}>仅显示可用消耗大于0的订单</Checkbox></span>
        </>
      } type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column 
          title="序号" 
          dataIndex="id"
          fixed="left"
          render={(text, record, index) => (currentPage - 1) * pageSize + index + 1} 
        />
        <Column 
          title="订单编号" 
          dataIndex="number" 
          fixed="left"
          render={(text, record) => (
            <Link 
              to={cryptoParamsIntoUrl(record.type === 0 ? '/orderDirect/directDetail' : '/orderAgent/agentDetail', { id: record.id })} 
              target="_blank"
            >
              {text}
            </Link>
          )}
        />
        <Column title="客户名称" dataIndex="client" />
        <Column title="XOAID" dataIndex="clientId" />
        <Column title="类型" dataIndex="typeName" />
        <Column title="订单类型" dataIndex="orderTypeName" />
        <Column title="厂商ID" dataIndex="vendor" />
        <Column title="项目" dataIndex="projectName" />
        <Column title="产品" dataIndex="productName" />
        <Column title="资金主体" dataIndex="fundCompanyName" />
        <Column title="市场价" dataIndex="colmarketprice" />
        <Column title="可用消耗" dataIndex="availableConsumption" />
        <Column title="实收" dataIndex="colactualprice" />
        <Column title="可用余额" dataIndex="availableBalance" />
        <Column title="预计收款" dataIndex="colpredictprice" />
        <Column title="收款类型" dataIndex="coltypeName" />
        <Column title="提单人" dataIndex="userName" />
        <Column title="订单负责人" dataIndex="currentUserName" />
        <Column 
          title="订单负责人员工编号" 
          dataIndex="currentUserNumber" 
          render={(text, record) => <>
            {text}
            <CopyToClipboard text={text} onCopy={() => message.success('复制成功')}>
              <span style={{ marginLeft: 10, color: '#168FFF', cursor: 'pointer' }}>复制</span>
            </CopyToClipboard>
          </>}
        />
        <Column title="订单生效时间" dataIndex="affectedate" />
      </Table>
    </div>
    <Drawer
      title="退单信息提交"
      width={600}
      onClose={() => setInfoVisible(false)}
      visible={infoVisible}
      destroyOnClose={true}
    >
      <SubmitInfo 
        setInfoVisible={setInfoVisible}
        infoData={infoData}
        history={history}
      />
    </Drawer>
  </>
}

export default Form.create()(RefundInfo)
